// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--MCAKn","iframe":"_2787e5dfdf--iframe--R4gH1","close":"_2787e5dfdf--close--KY2Sc","spinner":"_2787e5dfdf--spinner--leGCa"};